<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="coursePageEdit" :model="formData" class="full-width-input" style="width: 100%;" :rules="rules"
             label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="课程名称" prop="Course.courseName">
            <el-input class="input-item" v-model="formData.Course.courseName"
                      :clearable="true" placeholder="课程名称"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="授课专家" prop="Course.teachName">
            <el-input class="input-item"  v-model="formData.Course.teachName"
                      :key="specialistNameKey" @clear="clearSpecialist()"
                      :clearable="true" placeholder="专家" @focus="onSelectWarehouse()">
              <i class="el-icon-edit el-input__icon" slot="suffix" @click="onSelectWarehouse()"></i>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="归属行业" prop="Course.industryId">
            <el-cascader class="input-item" v-model="formData.Course.industryId" :options="coursePageEdit.industryId.impl.dropdownList" filterable
                         :clearable="true" :show-all-levels="false" placeholder="归属行业"
                         :props="{value: 'id', label: 'name', checkStrictly: true}"
                         @visible-change="coursePageEdit.industryId.impl.onVisibleChange"
                         @change="onIndustryIdValueChange"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="关键词" prop="Course.keyWord">
            <el-input class="input-item" v-model="formData.Course.keyWord"
                      :clearable="true" placeholder="关键词"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="课程简介" prop="Course.courseDesc">
            <el-input class="input-item" v-model="formData.Course.courseDesc"
                      type="textarea"
                      :autosize="{minRows: 8, maxRows: 16}"
                      :clearable="true" placeholder="请输入课程简介"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="课程封面" prop="Course.courseImages">
            <el-upload
              class="upload-image-item" name="uploadFile" :headers="getUploadHeaders"
              :action="getUploadActionUrl('/admin/app/course/upload')"
              :data="{fieldName: 'courseImages', asImage: true}"
              :on-success="onCourseImagesUploadSuccess"
              :on-remove="onCourseImagesRemoveFile"
              :before-upload="pictureFile"
              :on-error="onUploadError"

              :show-file-list="false">
              <div v-if="coursePageEdit.courseImages.impl.fileList && coursePageEdit.courseImages.impl.fileList[0] != null" style="position: relative">
                <img class="upload-image-show"
                     :src="coursePageEdit.courseImages.impl.fileList[0].url" />
                <div class="upload-img-del el-icon-close"
                     @click.stop="onCourseImagesRemoveFile(null, null)" />
              </div>
              <i v-else class="el-icon-plus upload-image-item"></i>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col class="table-box gutter-bottom" :span="24">
          <el-row type="flex" justify="end" style="margin-bottom: 20px;">
            <el-button type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('coursePageEdit:coursePageEdit:ChapterEdit')"
                       @click="onChapterEditClick()">
              新增课程章节
            </el-button>
          </el-row>
          <el-table ref="courseChapter" :data="coursePageEdit.CourseChapter.impl.dataList" :size="defaultFormItemSize" @sort-change="coursePageEdit.CourseChapter.impl.onSortChange"
                    header-cell-class-name="table-header-gray"
          >
            <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="coursePageEdit.CourseChapter.impl.getTableIndex" />
            <el-table-column label="章节名称" prop="chapterName">
            </el-table-column>
            <el-table-column label="封面" min-width="100px">
              <template slot-scope="scope">
                <el-image v-for="item in parseUploadData(scope.row.chapterImages, {id: scope.row.id, fieldName: 'chapterImages', asImage: true})"
                          :preview-src-list="getPictureList(scope.row.chapterImages, {id: scope.row.id, fieldName: 'chapterImages', asImage: true})"
                          class="table-cell-image" :key="item.url" :src="item.url" fit="fill">
                  <div slot="error" class="table-cell-image">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </template>
            </el-table-column>
            <el-table-column label="类型" prop="chapterTypeDictMap.name">
            </el-table-column>
            <el-table-column label="章节时长" prop="chapterTotalTime">
            </el-table-column>
            <el-table-column label="学习积分" prop="chapterScoreDictMap.name">
            </el-table-column>
            <el-table-column label="显示顺序" prop="showOrder">
            </el-table-column>
            <el-table-column label="操作" fixed="right">
              <template slot-scope="scope">
                <el-button @click.stop="onChapterRowEditClick(scope.row)" type="text" :size="defaultFormItemSize"
                           :disabled="!checkPermCodeExist('coursePageEdit:coursePageEdit:ChapterRowEdit')">
                  编辑
                </el-button>
                <el-button @click.stop="onRowDeleteClick(scope.row)" type="text" :size="defaultFormItemSize"
                           :disabled="!checkPermCodeExist('coursePageEdit:coursePageEdit:rowDelete')">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="24">
          <el-row class="no-scroll" :gutter="20" style="height: 20px">
          </el-row>
        </el-col>
        <el-col :span="24" class="gutter-bottom">
          <el-row class="no-scroll flex-box" type="flex" justify="center" style="height: px">
            <el-button type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('coursePageEdit:coursePageEdit:update')"
                       @click="onUpdateClick()">
              保存
            </el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
    <label v-if="closeVisible == '1'" class="page-close-box">
      <el-button type="text" @click="onCancel(true)" icon="el-icon-close" />
    </label>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { CourseChapterController, CourseController, DictionaryController } from '@/api';
import chapterEdit from '@/views/course/chapterEdit.vue';
import specialistSelect from '@/components/specialistSelect';
export default {
  name: 'coursePageEdit',
  props: {
    id: {
      default: undefined
    },
    closeVisible: {
      type: [Number, String],
      default: 0
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin],
  data () {
    return {
      specialistNameKey: 0,
      formData: {
        Course: {
          id: this.id,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          orgCode: undefined,
          deletedFlag: undefined,
          courseName: undefined,
          courseImages: undefined,
          teachId: undefined,
          teachName: undefined,
          courseDesc: undefined,
          industryId: undefined,
          industryName: undefined,
          totalTime: undefined,
          chapterNumber: undefined,
          keyWord: undefined,
          coursePicture: undefined,
          courseFiles: undefined,
          auditStatus: undefined,
          upFlag: undefined,
          visitUserNumber: undefined,
          courseScore: undefined,
          courseChapter: {
          },
          comment: {
          },
          isDatasourceInit: false
        }
      },
      rules: {
        'Course.courseName': [
          {required: true, message: '请输入课程名称', trigger: 'change'}
        ],
        'Course.teachName': [
          {required: true, message: '请选择授课专家'}
        ],
        'Course.industryId': [
          {required: true, message: '请选择归属行业', trigger: 'change'}
        ],
        'Course.courseDesc': [
          {required: true, message: '请输入课程简介', trigger: 'change'}
        ]
      },
      coursePageEdit: {
        formFilter: {
        },
        formFilterCopy: {
        },
        teachId: {
          impl: new DropdownWidget(this.loadTeachIdDropdownList)
        },
        industryId: {
          impl: new DropdownWidget(this.loadIndustryIdDropdownList, true, 'id', 'parentId'),
          value: []
        },
        courseImages: {
          impl: new UploadWidget(1)
        },
        CourseChapter: {
          impl: new TableWidget(this.loadCourseChapterWidgetData, this.loadCourseChapterVerify, false, false, 'showOrder', 1)
        },
        whiteBlock: {
          isInit: false
        },
        menuBlock: {
          isInit: false
        },
        isInit: false
      }
    }
  },
  methods: {
    onCancel (isSuccess) {
      this.removeCachePage(this.$options.name);
      this.refreshParentCachedPage = isSuccess;
      this.$router.go(-1);
    },
    /**
     * 课程章节关联配置数据获取函数，返回Promise
     */
    loadCourseChapterWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params
      }
      return new Promise((resolve, reject) => {
        params.courseChapterDtoFilter = {
          courseId: this.formData.Course.id
        }
        CourseChapterController.list(this, params).then(res => {
          // 级联更新设置临时唯一id
          let tempTime = new Date().getTime();
          resolve({
            dataList: res.data.dataList.map((item, index) => {
              return {
                __cascade_add_temp_id__: tempTime + index,
                ...item
              }
            }),
            totalCount: res.data.totalCount
          });
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 课程章节关联配置数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadCourseChapterVerify () {
      return true;
    },
    onSelectWarehouse () {
      this.specialistNameKey += 1
      this.$dialog.show('选择专家', specialistSelect, {
        area: ['1000px', '600px']
      }, {}).then(res => {
        // alert(JSON.stringify(res))
        this.formData.Course.teachId = res.id
        this.formData.Course.teachName = res.specialistName
        this.$forceUpdate()
      }).catch(e => {
      });
    },
    clearSpecialist () {
      this.formData.Course.teachId = ''
      this.formData.Course.teachName = ''
      this.$forceUpdate()
    },
    /**
     * 授课专家下拉数据获取函数
     */
    loadTeachIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictSysUserDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 授课专家选中值改变
     */
    onTeachIdValueChange (value) {
    },
    /**
     * 归属行业下拉数据获取函数
     */
    loadIndustryIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictIndustryDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 归属行业选中值改变
     */
    onIndustryIdValueChange (value) {
      this.formData.Course.industryId = Array.isArray(value) ? value[value.length - 1] : undefined;
    },
    /**
     * 更新课程信息编辑
     */
    refreshCoursePageEdit (reloadData = false) {
      this.loadCourseData().then(res => {
        if (reloadData) {
          this.coursePageEdit.CourseChapter.impl.refreshTable(true, 1);
        } else {
          this.coursePageEdit.CourseChapter.impl.refreshTable();
        }
        if (!this.coursePageEdit.isInit) {
          // 初始化下拉数据
          this.coursePageEdit.industryId.impl.onVisibleChange(true).then(res => {
            this.coursePageEdit.industryId.value = findTreeNodePath(res, this.formData.Course.industryId, 'id');
          }).catch(e => {});
        }
        this.coursePageEdit.isInit = true;
      }).catch(e => {});
    },
    /**
     * 保存
     */
    onUpdateClick () {
      if (this.coursePageEdit.CourseChapter.impl.dataList.length === 0) {
        this.$message.error('请新增课程章节！');
      } else {
        this.$refs.coursePageEdit.validate((valid) => {
          if (!valid) return;
          var industryName = ''
          var industryId = this.formData.Course.industryId
          this.coursePageEdit.industryId.impl.dropdownList.forEach(function (item, index) {
            if (industryId === item.id) {
              industryName = item.name;
            }
          });
          // var teachName = ''
          // var teachId = this.formData.Course.teachId
          // this.coursePageEdit.teachId.impl.dropdownList.forEach(function (item, index) {
          //   if (teachId === item.id) {
          //     teachName = item.name;
          //   }
          // });

          let params = {
            courseDto: {
              industryId: this.formData.Course.industryId,
              industryName: industryName,
              keyWord: this.formData.Course.keyWord,
              id: this.formData.Course.id,
              orgCode: this.formData.Course.orgCode,
              courseName: this.formData.Course.courseName,
              courseImages: this.formData.Course.courseImages,
              teachId: this.formData.Course.teachId,
              teachName: this.formData.Course.teachName,
              courseDesc: this.formData.Course.courseDesc,
              totalTime: this.formData.Course.totalTime,
              chapterNumber: this.formData.Course.chapterNumber,
              coursePicture: this.formData.Course.coursePicture,
              courseFiles: this.formData.Course.courseFiles,
              auditStatus: this.formData.Course.auditStatus,
              upFlag: this.formData.Course.upFlag,
              visitUserNumber: this.formData.Course.visitUserNumber,
              courseScore: this.formData.Course.courseScore
            },
            courseChapterDtoList: this.coursePageEdit.CourseChapter.impl.dataList
          };

          if (this.id === undefined) {
            params.courseDto.upFlag = '0'
            CourseController.add(this, params).then(res => {
              this.$message.success('保存成功');
              this.refreshCoursePageEdit();
            }).catch(e => {});
          } else {
            CourseController.update(this, params).then(res => {
              this.$message.success('保存成功');
              this.refreshCoursePageEdit();
            }).catch(e => {});
          }
          this.onCancel(true);
        });
      }
    },
    /**
     * 新增课程章节
     */
    onChapterEditClick (row) {
      let params = {
        courseId: this.id,
        rowData: {
          obligatoryFlag: '1',
          chapterType: '1'
        }
      };

      params.supportCascadeAdd = '1';

      this.$dialog.show('新增课程章节', chapterEdit, {
        area: '800px'
      }, params).then(res => {
        this.coursePageEdit.CourseChapter.impl.dataList.push({
          ...res,
          // 级联添加每次添加后并不保存到数据库，设置临时的唯一值
          __cascade_add_temp_id__: new Date().getTime()
        });
      }).catch(e => {});
    },
    /**
     * 编辑
     */
    onChapterRowEditClick (row) {
      let params = {};

      params.supportCascadeAdd = '1';

      // 编辑级联表格数据需要把当前数据传入弹窗
      params.rowData = row;

      this.$dialog.show('编辑', chapterEdit, {
        area: '800px'
      }, params).then(res => {
        this.coursePageEdit.CourseChapter.impl.dataList = this.coursePageEdit.CourseChapter.impl.dataList.map(item => {
          if (item.__cascade_add_temp_id__ === row.__cascade_add_temp_id__) {
            item = {
              ...res
            }
          }
          return item;
        });
      }).catch(e => {});
    },
    /**
     * 删除
     */
    onRowDeleteClick (row) {
      this.$refs.coursePageEdit.validate((valid) => {
        if (!valid) return;
        this.$confirm('确认删除？').then(res => {
          this.coursePageEdit.CourseChapter.impl.dataList = this.coursePageEdit.CourseChapter.impl.dataList.filter(item => {
            return item.__cascade_add_temp_id__ !== row.__cascade_add_temp_id__;
          });
        }).catch(e => {});
      });
    },
    onResume () {
      this.refreshCoursePageEdit(true);
    },
    /**
     * 获取课程表详细信息
     */
    loadCourseData () {
      return new Promise((resolve, reject) => {
        if (!this.formData.Course.isDatasourceInit) {
          if (
            this.id == null
          ) {
            this.resetFormData();
            reject();
            return;
          }
          let params = {
            id: this.id
          };
          CourseController.view(this, params).then(res => {
            this.formData.Course = {...res.data, isDatasourceInit: true};
            if (this.formData.Course.teachIdDictMap && this.coursePageEdit.teachId.impl.dirty) {
              // this.coursePageEdit.teachId.impl.dropdownList = [this.formData.Course];
              this.formData.Course.teachName = this.formData.Course.teachIdDictMap.name
            }
            if (this.formData.Course.industryIdDictMap && this.coursePageEdit.industryId.impl.dirty) {
              this.coursePageEdit.industryId.impl.dropdownList = [this.formData.Course.industryIdDictMap];
            }
            if (this.formData.Course.industryId) this.coursePageEdit.industryId.value = [this.formData.Course.industryId];
            let courseImagesDownloadParams = {
              id: this.formData.Course.id,
              fieldName: 'courseImages',
              asImage: true
            }
            this.coursePageEdit.courseImages.impl.fileList = this.parseUploadData(this.formData.Course.courseImages, courseImagesDownloadParams);
            resolve();
          }).catch(e => {
            reject();
          });
        } else {
          this.formData.Course.isDatasourceInit = true;
          resolve();
        }
      });
    },
    initFormData () {
    },
    /**
     * 课程封面上传成功
     */
    onCourseImagesUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.url = URL.createObjectURL(file.raw);
        this.coursePageEdit.courseImages.impl.onFileChange(file, fileList);
        this.formData.Course.courseImages = this.fileListToJson(this.coursePageEdit.courseImages.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
     * 移除课程封面
     */
    onCourseImagesRemoveFile (file, fileList) {
      this.coursePageEdit.courseImages.impl.onFileChange(file, fileList);
      this.formData.Course.courseImages = this.fileListToJson(this.coursePageEdit.courseImages.impl.fileList);
    },
    onUploadError (e, file, fileList) {
      this.$message.error('文件上传失败');
    },
    onUploadLimit (files, fileList) {
      this.$message.error('已经超出最大上传个数限制');
    },
    /**
     * 重置表单数据
     */
    resetFormData () {
      this.formData = {
        Course: {
          id: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          orgCode: undefined,
          deletedFlag: undefined,
          courseName: undefined,
          courseImages: undefined,
          teachId: undefined,
          teachName: undefined,
          courseDesc: undefined,
          industryId: undefined,
          industryName: undefined,
          totalTime: undefined,
          chapterNumber: undefined,
          keyWord: undefined,
          coursePicture: undefined,
          courseFiles: undefined,
          auditStatus: undefined,
          upFlag: undefined,
          visitUserNumber: undefined,
          courseScore: undefined,
          courseChapter: {
          },
          comment: {
          },
          isDatasourceInit: false
        }
      }
    },
    formInit () {
      this.refreshCoursePageEdit();
    }
  },
  computed: {
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  },
  watch: {
  }
}
</script>
